import List from './components/List';
import { Card, CardDescription, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const ListGlobalCurrenciesPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Currencies</CardTitle>
        <CardDescription>Currencies that are available in the Zebel.</CardDescription>
      </CardHeader>

      <CardContent>
        <List />
      </CardContent>
    </Card>
  );
};

export default ListGlobalCurrenciesPage;
